/* Layout */
import Layout from '../views/admin/layout/Layout'

const asyncRouterMap = [
  /*   ========  ========  ======== */
  /*  ========   MY BOAT  ======== */
  /* ========  ========  ======== */
  {
    path: '/z/:branchId/mybps/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Profil',
    meta: { relationRoles: ['Owner'], feature: 'myboat', title: 'MyPetrol' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/profil_boat'),
        meta: { title: 'Profil' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mybps/fleetcard',
    component: Layout,
    redirect: '',
    name: 'Kapal/Bot',
    meta: { relationRoles: ['Owner'], feature: 'myboat', title: 'Kapal/Bot' },
    children: [
      {
        path: 'maklumatfleetcardsemasa',
        component: () => import('@/views/myboat/maklumatfleetcardsemasa_boat'),
        meta: { title: 'Maklumat Kapal/Bot' }
      },
      // {
      //   path: 'permohonantambahkenderaan',
      //   component: () => import('@/views/myboat/permohonantambahkenderaan_boat'),
      //   meta: { title: 'Permohonan Tambah Kenderaan' }
      // },
      {
        path: 'tambahkenderaan',
        component: () => import('@/views/myboat/tambahkenderaan_boat'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahkenderaan',
        component: () => import('@/views/myboat/mulatambahkenderaan_boat'),
        meta: { title: 'Tambah Kenderaan' },
        hidden: true
      },
      {
        path: 'mulatambahsyarikatminyak',
        component: () => import('@/views/myboat/mulatambahsyarikatminyak_boat'),
        meta: { title: 'Tambah Syarikat Minyak' },
        hidden: true
      },
      // {
      //   path: 'senaraifleetcard',
      //   component: () => import('@/views/myboat/senaraifleetcard_boat'),
      //   meta: { title: 'Senarai Fleet Card' }
      // },
      // {
      //   path: 'permohonanpertukaransyarikatminyak',
      //   component: () => import('@/views/myboat/permohonanpertukaransyarikatminyak_boat'),
      //   meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      // },
      {
        path: 'tuntutan',
        component: () => import('@/views/myboat/tuntutan_boat'),
        meta: { title: 'Tuntutan' },
      },
      
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/myboat/rayuan_boat'),
      //   meta: { title: 'Rayuan' },
      // },
      {
        path: 'keduatukarsyarikatminyak',
        component: () => import('@/views/myboat/keduatukarsyarikatminyak_boat'),
        meta: { title: 'Tukar Syarikat Minyak' },
        hidden: true
      },
    ],
    noCollapse: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mybps/halamanutama',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Halaman Utama',
  //   meta: { relationRoles: ['kpdnadmin', 'enforcer', 'cawanganuser'], feature: 'myboat', title: 'Halaman Utama' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/dashboardduplicate_boat2'),
  //       meta: { title: 'Halaman Utama' },
  //     },
  //   ],
  //   branch: true
  // },
  // Pengguna Awam, Pemegang Akaun and Surat Kelulusan are hidden from the staff sidebar
  // (2026-10-20): MyBot is administered from /ext. The routes stay so their URLs resolve.
  {
    path: '/z/:branchId/mybps/halamanutama',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Pengguna' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/senaraipengguna_boat'),
        meta: { title: 'Pengguna Awam' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mybps/pengguna',
    component: Layout,
    redirect: '',
    name: 'Pengguna',
    meta: { relationRoles: ['enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'myboat', title: 'Pengguna' },
    children: [
      {
        path: 'senaraipengguna',
        component: () => import('@/views/myboat/senaraipengguna_boat'),
        meta: { title: 'Pengguna Awam' }
      },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mybps/admin',
    component: Layout,
    redirect: '',
    name: 'Fleet Card',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser'], feature: 'myboat', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/myboat/pemegangakaun_boat'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'pertukaransyarikatminyak',
      //   component: () => import('@/views/myboat/pertukaransyarikatminyak_boat'),
      //   meta: { title: 'Pertukaran Syarikat Minyak' },
      // },
      // {
      //   path: 'rayuan',
      //   component: () => import('@/views/myboat/fleetcardvehicleappeals_boat'),
      //   meta: { title: 'Rayuan' }
      // },
      // {
      //   path: 'kuotatambahan',
      //   component: () => import('@/views/myboat/kuotatambahan_boat'),
      //   meta: { relationRoles: ['kpdnadmin'], title: 'Kuota Tambahan' }
      // },
    ],
    hidden: true,
    branch: true
  },
  {
    path: '/z/:branchId/mybps/admin',
    component: Layout,
    redirect: '',
    name: 'Surat Kelulusan',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser'], feature: 'myboat', title: 'Surat Kelulusan' },
    children: [
      {
        path: 'suratkelulusan',
        component: () => import('@/views/myboat/pemegangakaunlily_boat'),
        meta: { title: 'Surat Kelulusan' }
      },
    ],
    hidden: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/mybps/rayuan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Rayuan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Rayuan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/fleetcardvehicleappeals_boat'),
  //       meta: { title: 'Rayuan' }
  //     }
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mybps/system',
    component: Layout,
    redirect: '',
    name: 'Pengurusan Sistem',
    meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Pengurusan Sistem' },
    children: [
      // {
      //   path: 'tetapanrekodpenggunaan',
      //   component: () => import('@/views/myboat/tetapanrekodpenggunaan_boat'),
      //   meta: { title: 'Tetapan Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'detailrekodpenggunaan',
      //   component: () => import('@/views/myboat/detailrekodpenggunaan_boat'),
      //   meta: { title: 'Detail - Rekod Penggunaan Kuota' },
      // },
      // {
      //   path: 'oilcompanies',
      //   component: () => import('@/views/codestructor/oilcompanies_boat'),
      //   meta: { title: 'Tetapan Syarikat Minyak' },
      // },
      // Harga Pam Mingguan is the group's only sidebar entry, so it stays first: SidebarItem
      // renders a one-visible-child group from children[0].
      {
        path: 'tetapanhargatuntutan',
        component: () => import('@/views/myboat/tetapanhargatuntutan_boat'),
        meta: { title: 'Harga Pam Mingguan' },
      },
      {
        path: 'tetapanjenisbadan',
        component: () => import('@/views/myboat/tetapanjenisbadan_boat'),
        meta: { title: 'Tetapan Jenis Badan' },
        hidden: true
      },
      {
        path: 'tetapanjeniskegunaan',
        component: () => import('@/views/myboat/tetapanjeniskegunaan_boat'),
        meta: { title: 'Tetapan Kelas Kegunaan' },
        hidden: true
      },
      {
        path: 'dashboardtetapanjenisbadan',
        component: () => import('@/views/myboat/dashboardtetapanjenisbadan_boat'),
        meta: { title: 'Tetapan Deskripsi Umum (Halaman Utama)' },
        hidden: true
      },
      // {
      //   path: 'kandungan_portal',
      //   component: () => import('@/views/myboat/kandunganportal_boat'),
      //   meta: { title: 'Kandungan Portal' },
      // },
      // {
      //   path: 'kandunganbanner',
      //   component: () => import('@/views/myboat/kandunganbanner_boat'),
      //   meta: { title: 'Kandungan Banner' },
      // },
    ],
    branch: true
  },
  // {
  //   path: '/z/:branchId/mybps/sekatan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Sekatan',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Sekatan' },
  //   children: [
  //     {
  //       path: 'senaraisekatan',
  //       component: () => import('@/views/myboat/senaraisekatan_boat'),
  //       meta: { title: 'Senarai Sekatan' }
  //     },
  //   ],
  //   alwaysShow: true,
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/carian',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Carian Pemegang Akaun atau Kenderaan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/halamanutama_boat'),
  //       meta: { title: 'Carian Pemegang Akaun atau Kenderaan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/admin',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Admin',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Admin' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/halamanutama_boat'),
  //       meta: { title: 'Admin' }
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mybps/tuntutan',
    component: Layout,
    redirect: '',
    name: 'Tuntutan',
    meta: { relationRoles: ['kpdnadmin', 'enforcer', 'callcenteruser', 'cawanganuser', 'stateuser'], feature: 'myboat', title: 'Tuntutan' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/tuntutanadmin_boat'),
        meta: { title: 'Tuntutan' }
      },
    ],
    branch: true
  },
  // Negeri (stateuser) uses the Tuntutan route above since 2026-10-20. This entry shared
  // Pengguna Awam's path, so the router resolved it to the Pengguna Awam page instead.
  // {
  //   path: '/z/:branchId/mybps/pengguna',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Tuntutan',
  //   meta: { relationRoles: ['stateuser'], feature: 'myboat', title: 'Tuntutan' },
  //   children: [
  //     {
  //       path: 'senaraipengguna',
  //       component: () => import('@/views/myboat/tuntutanadmin_boat'),
  //       meta: { title: 'Tuntutan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/search',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Carian',
  //   meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'myboat', title: 'Carian' },
  //   children: [
  //     {
  //       path: 'ssm',
  //       component: () => import('@/views/mypetrol/searchssm_petrol'),
  //       meta: { title: 'Semakan Data Syarikat' },
  //     },
  //     {
  //       path: 'jpn',
  //       component: () => import('@/views/mypetrol/searchjpn_petrol'),
  //       meta: { relationRoles: ['kpdnadmin'], title: 'Semakan Data Pemilikan Tunggal' },
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/laporan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Laporan',
  //   meta: { relationRoles: ['kpdnadmin', 'callcenteruser'], feature: 'myboat', title: 'Laporan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/laporan_boat'),
  //       meta: { title: 'Laporan' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/systemsettingsnextlevel',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Tetapan Sistem',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Tetapan Sistem' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/systemsettings_boat'),
  //       meta: { title: 'Tetapan Sistem' },
  //       hidden: true
  //     },
  //   ],
  //   hidden: true,
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/manual',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Manual',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'Manual' },
  //   children: [
  //     {
  //       path: 'manualpegawai',
  //       component: () => import('@/views/myboat/blank_boat'),
  //       meta: { title: 'Manual Pegawai' },
  //     },
  //     {
  //       path: 'manualpengguna',
  //       component: () => import('@/views/myboat/blank_boat'),
  //       meta: { title: 'Manual Pengguna' },
  //     },
  //   ],
  //   branch: true
  // },
  {
    path: '/z/:branchId/mybps/halamanutama',
    component: Layout,
    redirect: '',
    name: 'OILCO Halaman Utama',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'myboat', title: 'MyPetrol' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/halamanutamaoilcompany_boat'),
        meta: { title: 'Halaman Utama' }
      },
    ],
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/myboat',
    component: Layout,
    redirect: '',
    name: 'OILCO Fleet Card',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'myboat', title: 'Fleet Card' },
    children: [
      {
        path: 'pemegangakaun',
        component: () => import('@/views/myboat/pemegangakaunoilcompany_boat'),
        meta: { title: 'Pemegang Akaun' }
      },
      // {
      //   path: 'permohonanpertukaransyarikatminyak',
      //   component: () => import('@/views/myboat/permohonanpertukaransyarikatminyakoilcompany_boat'),
      //   meta: { title: 'Permohonan Pertukaran Syarikat Minyak' }
      // },
    ],
    noCollapse: true,
    alwaysShow: true,
    branch: true,
    hidden: true
  },
  // {
  //   path: '/z/:branchId/mybps/rekodpenggunaan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Laporan',
  //   meta: { relationRoles: ['oilcompanyuser'], feature: 'myboat', title: 'Laporan' },
  //   children: [
  //     {
  //       path: 'detailmonthquotaoilcompany',
  //       component: () => import('@/views/myboat/detailmonthquotaoilcompany_simplepetrol'),
  //       meta: { title: 'Laporan Pemegang Akaun' }
  //     },
  //     {
  //       path: 'kuotatambahan',
  //       component: () => import('@/views/myboat/kuotatambahanoilcompany_boat'),
  //       meta: { title: 'Laporan Kuota Tambahan' }
  //     },
  //   ],
  //   noCollapse: true,
  //   alwaysShow: true,
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/sekatan',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Sekatan',
  //   meta: { relationRoles: ['oilcompanyuser'], feature: 'myboat', title: 'Sekatan' },
  //   children: [
  //     {
  //       path: 'senaraisekatan',
  //       component: () => import('@/views/myboat/senaraisekatanoilcompany_boat'),
  //       meta: { title: 'Senarai Sekatan' }
  //     },
  //   ],
  //   noCollapse: true,
  //   alwaysShow: true,
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/lpagenerator',
  //   component: Layout,
  //   redirect: '',
  //   name: 'LPA Generator',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'LPA Generator' },
  //   children: [
  //     {
  //       path: 'lpagenerator',
  //       component: () => import('@/views/myboat/lpagenerator_boat'),
  //       meta: { title: 'LPA Generator' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/lpadownload',
  //   component: Layout,
  //   redirect: '',
  //   name: 'LPA Download',
  //   meta: { relationRoles: ['kpdnadmin'], feature: 'myboat', title: 'LPA Download' },
  //   children: [
  //     {
  //       path: 'lpadownload',
  //       component: () => import('@/views/myboat/lpadownload_boat'),
  //       meta: { title: 'LPA Download' }
  //     },
  //   ],
  //   branch: true
  // },
  // {
  //   path: '/z/:branchId/mybps/halamanutama',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Sekatan',
  //   meta: { relationRoles: ['enforcer'], feature: 'myboat', title: 'Sekatan' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/myboat/senaraisekatan_boat'),
  //       meta: { title: 'Senarai Sekatan' }
  //     },
  //   ],
  //   noCollapse: true,
  //   alwaysShow: true,
  //   branch: true
  // },
  /* ========  ========  ======== */
  /*  ========   MY BOAT — DOORS INTO /ext  ======== */
  /* ========  ========  ======== */
  // Each entry is a normal route whose view navigates to the MySubsidi Ext bundle on
  // mount; the sidebar keeps rendering <router-link> as it always has. The child's
  // meta.extPath is what the view reads ($route.meta is the deepest matched record's),
  // and the child's meta.title is what the sidebar shows for a one-child entry.
  {
    path: '/z/:branchId/mybps/pendaftaranbot',
    component: Layout,
    redirect: '',
    name: 'Pendaftaran Bot',
    meta: { relationRoles: ['Owner'], feature: 'myboat', title: 'Pendaftaran Bot' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/extredirect_boat'),
        meta: { title: 'Pendaftaran Bot', extPath: '/bps/bot' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mybps/pentadbiranbps',
    component: Layout,
    redirect: '',
    name: 'Pentadbiran BPS',
    meta: { relationRoles: ['kpdnadmin', 'callcenteruser', 'stateuser'], feature: 'myboat', title: 'Pentadbiran BPS' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/extredirect_boat'),
        meta: { title: 'Pentadbiran BPS', extPath: '/bps/tadbir/bot' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mybps/laporanbps',
    component: Layout,
    redirect: '',
    name: 'Laporan BPS',
    meta: { relationRoles: ['oilcompanyuser'], feature: 'mypetrol', title: 'Laporan BPS' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/extredirect_boat'),
        meta: { title: 'Laporan BPS', extPath: '/bps/laporan' }
      },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/mybps/semakanbot',
    component: Layout,
    redirect: '',
    name: 'Semakan Bot',
    meta: { relationRoles: ['bpsagencyuser'], feature: 'myboat', title: 'Semakan Bot' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/extredirect_boat'),
        meta: { title: 'Semakan Bot', extPath: '/bps/semakan' }
      },
    ],
    branch: true
  },
  // The MyBot card's door. No feature and no relationRoles on purpose: it must exist
  // for every role, because the persona is resolved on ext's side — /bps is a landing
  // that forwards each one to its own page. Hidden, so it never appears in the sidebar.
  {
    path: '/z/:branchId/mybps/ext',
    component: Layout,
    redirect: '',
    name: 'MyBot',
    meta: { title: 'MyBot' },
    children: [
      {
        path: '',
        component: () => import('@/views/myboat/extredirect_boat'),
        meta: { title: 'MyBot', extPath: '/bps' }
      },
    ],
    hidden: true,
    branch: true
  },
]

export default asyncRouterMap



// WEBPACK FOOTER //
// ./src/router/myboat.js